import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageService } from '@mzic/mzic-services';

const normalizeLang = (lang: string | undefined): 'pt-br' | 'en' => {
  if (lang?.toLowerCase().startsWith('pt')) {
    return 'pt-br';
  }
  return 'en';
};

export const collectionLanguageGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const translocoService = inject(TranslocoService);
  const languageService = inject(LanguageService);

  const langParam = route.params['lang'] || route.parent?.params?.['lang'];
  const collectionId =
    route.params['collectionId'] || route.parent?.params?.['collectionId'];
  const revisionId =
    route.params['revisionId'] || route.parent?.params?.['revisionId'];
  const targetId =
    route.params['targetId'] || route.parent?.params?.['targetId'];

  if (langParam) {
    const normalizedLang = normalizeLang(langParam);
    translocoService.setActiveLang(normalizedLang);
    languageService.languageState.set(normalizedLang);
    return true;
  }

  const browserLang = normalizeLang(languageService.getBrowserLanguage());
  if (collectionId) {
    const commands = ['/', browserLang, 'collection', collectionId];
    if (revisionId && targetId) {
      commands.push('revisions', revisionId, 'targets', targetId);
    }
    return router.createUrlTree(commands, {
      queryParams: route.queryParams,
      fragment: route.fragment || undefined,
    });
  }

  return router.createUrlTree(['/', browserLang, 'collection'], {
    queryParams: route.queryParams,
    fragment: route.fragment || undefined,
  });
};
